// extracted by mini-css-extract-plugin
module.exports = {"ScreenError":"styles_ScreenError__2jtEC","ScreenError__Tile":"styles_ScreenError__Tile__V6Rax"};